import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';

export const useFeeAndRefundStore = defineStore('feeAndRefund', {
  state: () => ({
    rawData: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    currentType: 'fee', // 新增的 state 來儲存當前的 type
    filters: {
      driverName: '',
      driverId: '',
      fromDate: '',
      toDate: '',
      sort_by:'created_at',
      order:'desc',
    }
  }),
  actions: {
    async fetchFeesAndRefunds(type = this.currentType, page = this.currentPage, perPage = this.itemsPerPage) {
      this.currentType = type; // 更新當前的 type
      const url = `/api/admin/feeAndRefund/list`;
      let params = new URLSearchParams();
      params.append('type', this.currentType);
      params.append('per_page', perPage);
      params.append('page', page);

      if (this.filters.driverId) params.append('driver_id', this.filters.driverId);
      if (this.filters.driverName) params.append('driver_name', this.filters.driverName);
      if (this.filters.fromDate) params.append('from', this.formatDate(this.filters.fromDate));
      if (this.filters.toDate) params.append('to', this.formatDate(this.filters.toDate));
      if (this.filters.sort_by) params.append('sort_by', this.filters.sort_by);
      if (this.filters.order) params.append('order',  this.filters.order);


      try {
        const response = await useHttp().get(`${url}?${params.toString()}`);
        console.log(response.data);
        if (statusCheck(response.data)) {
          this.rawData = response.data.result;
          this.totalEntries = response.data.total;
          this.currentPage = page;
          this.itemsPerPage = perPage;
        } else {
          throw new Error('Data fetch failed');
        }
      } catch (error) {
        console.error('Error fetching fees and refunds:', error);
        this.rawData = [];
        throw error;
      }
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const month = `${d.getMonth() + 1}`.padStart(2, '0');
      const day = `${d.getDate()}`.padStart(2, '0');
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    async resetFilters() {
      this.filters = {
        driverName: '',
        driverId: '',
        fromDate: '',
        toDate: ''
      };
      await this.fetchFeesAndRefunds(); // 重置篩選後重新獲取數據
    },
    async createFeesAndRefund(payload) {
      try {
        const response = await useHttp().post('/api/admin/feeAndRefund/create', payload);
        if (statusCheck(response.data)) {
          Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.resetFilters();
        } else {
          return false;
        }
      } catch (error) {
        console.error('Error creating Fee/Refund:', error);
        throw error;
      }
    },
    async updateFeeAndRefund(payload) {
      try {
        const response = await useHttp().post('/api/admin/feeAndRefund/update', payload);
        if (statusCheck(response.data)) {
          Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          await this.fetchFeesAndRefunds(this.currentType, this.currentPage, this.itemsPerPage);
        } else {
          return false;
        }
      } catch (error) {
        console.error('Error updating Fee/Refund:', error);
        throw error;
      }
    },
    async changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        console.log(this.currentType, page, this.itemsPerPage);
        this.currentPage = page;
        await this.fetchFeesAndRefunds(this.currentType, page, this.itemsPerPage);
      }

    }
  },
  getters: {
    paginatedData(state) {
      return state.rawData;
    },
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    }
  }
});
